/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by Omnia
 * On: 13/Oct/2026.
 */
@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.ridepromocodes

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.ridepromocode.AdminRidePromoCodeDto

object UpsertRidePromoCodeEndpoint : EndPoint<UpsertRidePromoCodeEndpoint.Request, UpsertRidePromoCodeEndpoint.Response>() {
    class Request(
        val promoCode: AdminRidePromoCodeDto,
    )

    class Response
}